import Step2y0 from './Step2y0'

export default Step2y0